import React from 'react'
import '../styles/Events.css'

const Events = () => {
  const events2025 = {
    'MAY': [
      {
        title: "American Music Awards Gift Bag",
        description: "Exclusive gift bags for music's biggest stars"
      },
      {
        title: "Mother's Day in Hollywood Gift Bag",
        description: "Celebrity gifting and brand partnerships for Mother's Day events"
      }
    ],
    'SEPTEMBER': [
      {
        title: "Emmys Gift Bag and Backstage Giving Suite",
        description: "Television industry's premier awards show gift experiences"
      },
      {
        title: "LA Rams WAGs Luncheon",
        description: "Gift bags for the Los Angeles Rams' wives and girlfriends (WAGs)"
      },
      {
        title: "Atlanta Falcons Roster Party and WAGs Luncheon",
        description: "Gift bags for the Atlanta Falcons' roster party and wives and girlfriends (WAGs)"
      },
    ],
    'OCTOBER': [
      {
        title: "The Information's WTF Summit",
        description: "Gift bags for a gathering of bold women leaders in tech, media, and finance",
        link: 'https://www.theinformation.com/events/wtf-summit-2025'
      },
      {
        title: "FEME's Annual Event",
        description: "Gift bags for an event connecting top female executives in media and entertainment (FEME) while mentoring emerging talent",
        link: 'https://www.femelosangeles.com/'
      },
    ],
    'NOVEMBER': [
      {
        title: "Latin GRAMMY Awards®",
        description: "The Official Backstage Presenter & Performer Gift Lounge for the Latin GRAMMY Awards®",
        link: 'https://www.latingrammy.com/en/awards/26th-annual-latin-grammy-awards-2025'
      },
    ],
    'DECEMBER': [
      {
        title: "Dancing with the Stars Finalists",
        description: "Gift bags going to the finalists on Dancing with the Stars"
      },
      {
        title: "Denver Nuggets WAGS",
        description: "Gift bags for the Denver Nuggets' wives and girlfriends (WAGs)"
      },
      {
        title: "The Wrap Power Women Summit",
        description: "Gift bags for a gathering of women in the entertainment industry, sharing insights and experiences",
        link: 'https://powerwomensummit2025.splashthat.com/'
      },
    ]
  }

  const events2026 = {
    'FEBRUARY': [
      {
        title: "Official GRAMMY Awards® Gift Bag",
        description: "Gift bag and lounge for music's biggest night"
      },
      {
        title: "On Location's Super Bowl Gift Lounge",
        description: "Official hospitality partner of the NFL gift experience"
      },
      {
        title: "Mraz Foundation DREAM Event",
        description: "Gift bags for Jason Mraz Foundation's community concert event",
        link: 'https://artcenter.org/event/jmf_dream1/'
      },
    ],
    'MARCH': [
      {
        title: "Everyone Wins Gift Bag",
        description: "Independent gift bag going to the top 25 Oscar nominees"
      },

    ],
    'APRIL': [
      {
        title: "TIME 100",
        description: "Gift bags for the most influential people of this year"
      }
    ],
    'NOVEMBER': [
      {
        title: "Latin GRAMMY Awards® Official Talent Gift Lounge",
        description: "The Official Backstage Presenter & Performer Gift Lounge for the Latin GRAMMY Awards®"
      }
    ]
  }

  return (
    <div className='minHeight100'>
      <div className='events-hero-section hero-section'>
        <h2 className='pagetitle'>CALENDAR OF EVENTS</h2>
      </div>

      <div className='events-section'>
        <div className='section-container'>
          <div className='timeline-container'>
            
            {/* 2025 Events */}
            <div className='year-section'>
              <div className='year-header'>
                <h2 className='year-title'>2025</h2>
                <div className='year-line'></div>
              </div>
              
              {Object.entries(events2025).map(([month, monthEvents]) => (
                <div key={month} className='month-section'>
                  <div className='month-header'>
                    <h3 className='month-title'>{month}</h3>
                  </div>
                  <div className='month-events'>
                    {monthEvents.map((event, index) => (
                      <div key={index} className='calendar-event-card'>
                        <div className='calendar-event-content'>
                          <div className='calendar-event-details'>
                            <h4 className='calendar-event-title'>{event.title}</h4>
                            <p className='calendar-event-description'>{event.description}</p>
                            {
                              event.link &&
                              <div className='calendar-event-description-link'>
                                <a target="_blank" rel="noopener noreferrer" href={event.link}>Learn more</a>
                              </div>
                            }
                          </div>
                        </div>
                        <div className='calendar-event-overlay'></div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* 2026 Events */}
            <div className='year-section'>
              <div className='year-header'>
                <h2 className='year-title'>2026</h2>
                <div className='year-line'></div>
              </div>
              
              {Object.entries(events2026).map(([month, monthEvents]) => (
                <div key={month} className='month-section'>
                  <div className='month-header'>
                    <h3 className='month-title'>{month}</h3>
                  </div>
                  <div className='month-events'>
                    {monthEvents.map((event, index) => (
                      <div key={index} className='calendar-event-card'>
                        <div className='calendar-event-content'>
                          <div className='calendar-event-details'>
                            <h4 className='calendar-event-title'>{event.title}</h4>
                            <p className='calendar-event-description'>{event.description}</p>
                          </div>
                        </div>
                        <div className='calendar-event-overlay'></div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            
          </div>
        </div>
      </div>
    </div>
  )
}

export default Events